module.exports = __webpack_public_path__ + "static/img/part5.5d309e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/part5.png
// module id = IHXu
// module chunks = 0